export default "__VITE_ASSET__BXroTMYm__"